import { relations, sql } from "drizzle-orm";
import { boolean, integer, pgTable, text, timestamp, uuid, } from "drizzle-orm/pg-core";
export const sitemapEntry = pgTable("sitemap_entry", {
    loc: text("loc").notNull().unique(),
    lastmod: text("lastmod"),
    changefreq: text("changefreq"),
    priority: text("priority"),
    processed: boolean("processed").default(false).notNull(),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    creationDate: timestamp("creation_date", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    updatedAt: timestamp("updated_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const sitemapPageContent = pgTable("sitemap_page_content", {
    sitemapEntryId: uuid("sitemap_entry_id")
        .references(() => sitemapEntry.id, {
        onDelete: "cascade",
    })
        .notNull(),
    url: text("url").notNull(),
    htmlContent: text("html_content"),
    statusCode: integer("status_code"),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    creationDate: timestamp("creation_date", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const sitemapEntryRelations = relations(sitemapEntry, ({ many }) => ({
    pageContent: many(sitemapPageContent),
}));
export const sitemapPageContentRelations = relations(sitemapPageContent, ({ one }) => ({
    sitemapEntry: one(sitemapEntry, {
        fields: [sitemapPageContent.sitemapEntryId],
        references: [sitemapEntry.id],
    }),
}));
